import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Sidebar from "../../components/common/Sidebar";
import Header from "../../components/common/Header";
import client from "../../services/Client";
import Loading from "../../components/loader/Loading";
import { useSelector } from "react-redux";
import arrowLeft from "../../asessts/Images/arrow_left.svg";
import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { formatRole } from "../../utils/common";
import ImagePreviewModal from "../../components/common/ImagePreviewModal";
function PharmacyDetail() {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [blogDetails, setBlogDetails] = useState({});
  const pageSlice = useSelector((state) => state.pageSlice.pageSlice);
  const navigate = useNavigate();
  const { state } = useLocation();
  const activeTab = state?.activeTab;

  const fetchUserDetails = async () => {
    setIsLoading(true);
    try {
      const response = await client.get(
        `/admin/healthFacility/get-pharmacy/${id}`
      );
      console.log("pharmacy", response);
      setBlogDetails(response?.data?.data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching user details:", error);
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchUserDetails();
  }, [id]);

  const [isApproving, setIsApproving] = useState(false);
  const [isRejecting, setIsRejecting] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const handleStatusChange = async (status) => {
    if (status === "approved") {
      setIsApproving(true);
    } else {
      setIsRejecting(true);
    }

    try {
      const response = await client.put(
        `/admin/profile/change-status/${id}`,
        null,
        {
          params: { status },
        }
      );

      if (response.data.status) {
        toast.success(
          response.data.message || `Request ${status} successfully`
        );
        fetchUserDetails();
        navigate(-1);
      } else {
        toast.error(response.data.message || `Failed to ${status} request`);
      }
    } catch (error) {
      console.error(`Error ${status} request:`, error);
      toast.error(`Failed to ${status} request`);
    } finally {
      if (status === "approved") {
        setIsApproving(false);
      } else {
        setIsRejecting(false);
      }
    }
  };

  return (
    <>
      <div class="admin-dashboard">
        <Sidebar />
        <div class="main-dashboard subadmin-dashboard">
          <Header
            title={
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <img
                  src={arrowLeft}
                  alt="Back"
                  style={{ cursor: "pointer", width: "22px", height: "22px" }}
                  onClick={() =>
                    navigate(-1, { state: { activeTab: activeTab } })
                  }
                />
                <span>Requests</span>
              </div>
            }
          />
          {isLoading ? (
            <Loading />
          ) : (
            <div>
              <div class="setting-main request-main">
                <div class="setting-details">
                  <div class="basic-detail">
                    <div class="profile-upload">
                      <div class="profile-img">
                        <img src={blogDetails?.information?.image} alt="" />
                      </div>
                    </div>
                    <div class="profile-details">
                      <div class="profile-head">
                        <div class="">
                          <h2>
                            {blogDetails?.user?.firstName}{" "}
                            {blogDetails?.user?.lastName}
                          </h2>
                          <p>
                            <span>Request ID:</span> {blogDetails?.profileId}
                          </p>
                        </div>
                        {pageSlice === "request" && activeTab === "Pending" && (
                          <div className="reject-approve-btn">
                            <button
                              className="reject-btn"
                              onClick={() => handleStatusChange("rejected")}
                              disabled={isRejecting || isApproving}
                            >
                              {isRejecting ? "Processing..." : "Reject"}
                            </button>
                            <button
                              className="approve-btn"
                              onClick={() => handleStatusChange("approved")}
                              disabled={isApproving || isRejecting}
                            >
                              {isApproving ? "Processing..." : "Approve"}
                            </button>
                          </div>
                        )}
                      </div>
                      <div class="input-group">
                        <div class="input-field">
                          <label>Type</label>
                          <input
                            type="text"
                            placeholder="Henry"
                            value={formatRole(
                              blogDetails?.facilityOrProfession
                            )}
                          />
                        </div>
                        <div class="input-field">
                          <label>Role</label>
                          <input
                            type="text"
                            placeholder="Estward"
                            value={formatRole(blogDetails?.role)}
                          />
                        </div>
                        <div class="input-field">
                          <label>Phone Number</label>
                          <input
                            type="text"
                            placeholder="Email"
                            value={
                              blogDetails?.user?.phoneNumber?.number
                                ? `+${blogDetails?.user?.phoneNumber?.dialCode} ${blogDetails?.user?.phoneNumber?.number}`
                                : ""
                            }
                          />
                        </div>
                      </div>
                      <div class="input-group">
                        <div class="input-field">
                          <label>Email</label>
                          <input
                            type="text"
                            placeholder="Estward"
                            value={blogDetails?.user?.email}
                          />
                        </div>
                        <div class="input-field">
                          <label>Address</label>
                          <textarea
                            className="input-address"
                            placeholder="Address"
                            value={blogDetails?.information?.address?.add}
                          />
                        </div>
                        <div class="input-field"></div>
                      </div>
                      <div class="input-group">
                        {blogDetails?.information?.additionalText && (
                          <div class="input-field" style={{ width: "48%" }}>
                            <label>Additional Text</label>
                            <textarea
                              placeholder="Description"
                              value={blogDetails?.information?.additionalText}
                            ></textarea>
                          </div>
                        )}
                        {/* <div class="input-field" style={{ width: "48%" }}>
                        <label>Qualification</label>
                        <textarea
                          placeholder="Qualification"
                          value={`${blogDetails?.professionalDetails?.qualifications}(${blogDetails?.professionalDetails?.speciality})`}
                        ></textarea>
                      </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {blogDetails?.documents && (
                <div class="request-document">
                  <h3>Professional Documents</h3>
                  <div class="doc-main">
                    <div>
                      {blogDetails?.documents?.certificate && (
                        <div class="doc">
                          <div
                            class="doc-file"
                            onClick={() =>
                              setSelectedImage(
                                blogDetails?.documents?.certificate
                              )
                            }
                          >
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={blogDetails?.documents?.certificate}
                              alt=""
                            />
                          </div>
                          <div class="Document-name">
                            <span>
                              {blogDetails?.documents &&
                              Object.keys(blogDetails.documents).length > 0
                                ? Object.keys(blogDetails.documents)[0]
                                : "No document available"}
                            </span>
                          </div>
                        </div>
                      )}
                      {blogDetails?.documents?.license !== "" ? (
                        <div class="doc">
                          <div
                            class="doc-file"
                            onClick={() =>
                              setSelectedImage(blogDetails?.documents?.license)
                            }
                          >
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={blogDetails?.documents?.license}
                              alt=""
                            />
                          </div>
                          <div class="Document-name">
                            <span>
                              {blogDetails?.documents &&
                              Object.keys(blogDetails.documents).length > 0
                                ? Object.keys(blogDetails.documents)[1]
                                : "No document available"}
                            </span>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              )}
              <div class="doctors-details">
                <h3>Other Services</h3>
                {blogDetails?.otherServices?.map((service, index) => (
                  <div key={index} class="doc-main_one mt-3">
                    <p className="service-name">{service?.name}</p>
                    <p>{service?.information}</p>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
      {selectedImage && (
        <ImagePreviewModal
          imageUrl={selectedImage}
          onClose={() => setSelectedImage(null)}
        />
      )}
    </>
  );
}

export default PharmacyDetail;
